import React, { useEffect, useState } from 'react'
import {
    Tooltip,
    Box,
    Tabs,
    Tab,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Dialog,
    DialogContent,
    Chip,
    Button,
    MenuItem,
} from '@mui/material'
import { Formik } from 'formik'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SupplierDialog from '../Components/SupplierDialog';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import CreateIcon from '@mui/icons-material/Create';
import { toast, useToastContainer } from 'react-toastify';
import SearchIcon from '@mui/icons-material/Search';
import ItemDialog from '../Components/ItemDialog';
import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import logo from '../Assests/logo.jpg'
import ItemUpdateDialog from '../Components/ItemUpdateDialog';
import CalculatedFoodDialog from '../Components/CalculatedFoodDialog';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import KitchenItemDialog from '../Components/KitchenItemDialog';



function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`item-tabpanel-${index}`}
            aria-labelledby={`item-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

function ItemManagement() {
    const [pageTitle, setPageTitle] = useState('Manage Items');
    const [tabIndex, setTabIndex] = useState(0);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [updateDialogOpen, setupdateDialogOpen] = useState(false);
    const [calcFoodDialogOpen, setCalcFoodDialogOpen] = useState(false);
    const [calcFoodMainItem, setCalcFoodMainItem] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [itemList, setItemList] = useState([]);
    const [itemSearch, setItemSearch] = useState("");
    const [listImageView, setListImageView] = useState();
    const [imageDialog, setImageDialog] = useState(false);
    const [updateID, setUpdateID] = useState(0);
    const [selectedItem, setSelectedItem] = useState(null);
    const [status, setStatus] = useState(1);
    const [itemGridList, setItemGridList] = useState([]);

    const [kitchenItems, setKitchenItems] = useState([]);
    const [kitchenDialogOpen, setKitchenDialogOpen] = useState(false);
    const [kitchenEditingItem, setKitchenEditingItem] = useState(null);
    const [kitchenPage, setKitchenPage] = useState(0);
    const [kitchenRowsPerPage, setKitchenRowsPerPage] = useState(5);
    const [kitchenSearch, setKitchenSearch] = useState("");

    useEffect(() => {
        GetAllItemDetailForGrid();
    }, [])

    useEffect(() => {
        if (tabIndex === 1) {
            GetKitchenItems();
        }
    }, [tabIndex])

    useEffect(() => {
        if (updateID === 0 && dialogOpen === false) {
            GetAllItemDetailForGrid();
        }
    }, [updateID])

    useEffect(() => {
        GetAllItemDetailForGrid();
    }, [status])

    useEffect(() => {
        if (dialogOpen === false) {
            GetAllItemDetailForGrid();
        }
    }, [dialogOpen])

    function handleClick() {
        setDialogOpen(true);
    }

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const openKitchenAdd = () => {
        setKitchenEditingItem(null);
        setKitchenDialogOpen(true);
    };

    const openKitchenEdit = (row) => {
        setKitchenEditingItem(row);
        setKitchenDialogOpen(true);
    };

    const closeKitchenDialog = () => {
        setKitchenDialogOpen(false);
        setKitchenEditingItem(null);
    };

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - itemGridList.length) : 0;

    const filteredKitchenItems = kitchenItems.filter((row) =>
        String(row?.itemname || "").toLowerCase().includes(kitchenSearch.toLowerCase())
    );

    const kitchenEmptyRows =
        kitchenPage > 0 ? Math.max(0, (1 + kitchenPage) * kitchenRowsPerPage - filteredKitchenItems.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleKitchenChangePage = (event, newPage) => {
        setKitchenPage(newPage);
    };

    const handleKitchenChangeRowsPerPage = (event) => {
        setKitchenRowsPerPage(parseInt(event.target.value, 10));
        setKitchenPage(0);
    };

    function GetAllItemDetailForGrid() {
        axios.get('https://serverkf.ccsoftwares.com/Item/getItemDetails').then((res) => {
            if (res.data.length > 0) {
                setItemList(res.data);
                const FilterData = res.data.filter(itemStatus => itemStatus.IsActive === status);
                setItemGridList(FilterData);
            } else {
                setItemList([]);
                toast.error("No records to display!");
            }
        })
    }

    function GetKitchenItems() {
        axios
            .get('https://serverkf.ccsoftwares.com/kitchenitems')
            .then((res) => {
                setKitchenItems(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => {
                setKitchenItems([]);
                toast.error("Failed to fetch kitchen items");
            });
    }

    function ViewImage(itemImage) {
        setListImageView(itemImage);
        setImageDialog(true)
    }

    function UpdateRowData(row) {
        setSelectedItem(row);
        setUpdateID(row.ItemID);
        setupdateDialogOpen(true)
    }

    function OpenCalculatedFood(row) {
        setCalcFoodMainItem(row);
        setCalcFoodDialogOpen(true);
    }

    function removeImage() {
        setImageDialog(false)
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={11} xs={11}>
                    {titleName}
                </Grid>
                <Grid item md={1} xs={1}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center' >

                        <Button variant="contained" endIcon={<AddCircleOutlineIcon />} onClick={() => handleClick()} sx={{ width: '100%' }}>
                            Add
                        </Button>

                    </Box>
                </Grid>
            </Grid>
        )
    }

    function kitchenCardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={11} xs={11}>
                    {titleName}
                </Grid>
                <Grid item md={1} xs={1}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center' >
                        <Button variant="contained" endIcon={<AddCircleOutlineIcon />} onClick={() => openKitchenAdd()} sx={{ width: '100%' }}>
                            Add
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        )
    }

    return (
        <>
            <Container maxWidth={false} sx={{ paddingTop: '15vh' }}>
                <Box sx={{ width: '100%', mb: 2 }}>
                    <Tabs value={tabIndex} onChange={handleTabChange} centered>
                        <Tab label="Items" id="item-tab-0" aria-controls="item-tabpanel-0" />
                        <Tab label="Kitchen Items" id="item-tab-1" aria-controls="item-tabpanel-1" />
                    </Tabs>
                </Box>

                <TabPanel value={tabIndex} index={0}>
                    <Formik
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form >
                                <Card sx={{ padding: '15px' }}>
                                    <CardHeader
                                        title={cardTitle(pageTitle)}
                                    />
                                    <Divider />
                                    <br />
                                    <TableContainer>
                                        <Grid container spacing={2}>
                                            <Grid item md={6} sx={6}>
                                                <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                                    <TextField
                                                        sx={{ width: { md: '50%', xs: '60%' } }}
                                                        variant="outlined"
                                                        value={itemSearch}
                                                        onChange={(e) => { setItemSearch(e.target.value) }}
                                                        size='small'
                                                    />
                                                    <SearchIcon sx={{ color: 'action.active', mr: 1, my: 1 }} style={{ marginLeft: 10 }} />
                                                </Box>
                                            </Grid>
                                            <Grid item md={6} sx={6}>
                                                <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        onBlur={handleBlur}
                                                        name='status'
                                                        value={status}
                                                        id='status'
                                                        onChange={(e) => { setStatus(e.target.value) }}
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{ width: { md: '30%', xs: '60%' } }}
                                                    >
                                                        <MenuItem key={1} value={1}>Active</MenuItem>
                                                        <MenuItem key={0} value={0}>Inactive</MenuItem>
                                                    </TextField>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <br />
                                        <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>#</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>Item Name</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>Default Barcode</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>Item Category</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>Cost Price (Rs.)</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>Selling Price (Rs.)</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>Item Image</TableCell>
                                                    {/* <TableCell align='center' sx={{ fontWeight: 'bold' }}>Item Status</TableCell> */}
                                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(rowsPerPage > 0
                                                    ? itemGridList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : itemGridList
                                                ).filter((element) => {
                                                    if (itemSearch === "") {
                                                        return element;
                                                    } else if ((element.ItemName.toLowerCase().trim()).includes(itemSearch.toLowerCase().trim())) {
                                                        return element;
                                                    } else if ((element.CategoryName.toLowerCase().trim()).includes(itemSearch.toLowerCase().trim())) {
                                                        return element;
                                                    } else if (element.defbarcode && element.defbarcode.toString().toLowerCase().includes(itemSearch.toLowerCase().trim())) {
                                                        return element;
                                                    }
                                                }).map((row, index) => (
                                                    <TableRow key={row._id}>
                                                        <TableCell align='center'>{index + 1}</TableCell>
                                                        <TableCell align='center'>{row.ItemName}</TableCell>
                                                        <TableCell align='center'>{row.defBarcode ?? '-'}</TableCell>
                                                        <TableCell align='center'>{row.CategoryName}</TableCell>
                                                        <TableCell align='center'>{row.costPrice}</TableCell>
                                                        <TableCell align='center'>{row.sellingPrice}</TableCell>
                                                        <TableCell align='center'>
                                                            <IconButton onClick={() => ViewImage(row.ItemImage)}>
                                                                <VisibilityIcon sx={{ color: 'primary.main' }} />
                                                            </IconButton>
                                                        </TableCell>
                                                        {/* <TableCell align='center'>{row.IsActive == 1 ? <Chip label="Active" color="primary" /> : <Chip label="Inactive" color="error" />}</TableCell> */}
                                                        <TableCell align='center'>
                                                            <IconButton aria-label={`Update ${row.ItemName}`} onClick={() => UpdateRowData(row)}>
                                                                <CreateIcon sx={{ color: 'primary.main' }} />
                                                            </IconButton>
                                                            <IconButton onClick={() => OpenCalculatedFood(row)}>
                                                                <RestaurantMenuIcon sx={{ color: row.hasCalcFood == 1 ? 'green' : 'black' }} />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                                {emptyRows > 0 && (
                                                    <TableRow style={{ height: 53 * emptyRows }}>
                                                        <TableCell colSpan={9} />
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                            <TableFooter>
                                                <TableRow>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 35, { label: 'All', value: -1 }]}
                                                        colSpan={9}
                                                        count={itemGridList.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        slotProps={{
                                                            select: {
                                                                inputProps: {
                                                                    'aria-label': 'rows per page',
                                                                },
                                                                native: true,
                                                            },
                                                        }}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                        ActionsComponent={TablePaginationActions}
                                                    />
                                                </TableRow>
                                            </TableFooter>
                                        </Table>
                                    </TableContainer>

                                    {/* image preview dialog */}
                                    <Dialog open={imageDialog}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                paddingTop: "1vh",
                                                paddingRight: "1vw",
                                            }}
                                        >
                                            <IconButton>
                                                <CancelIcon
                                                    sx={{ color: "red", }}
                                                    onClick={removeImage}
                                                />
                                            </IconButton>
                                        </Box>
                                        <DialogContent>
                                            <Card
                                                style={{
                                                    height: 400,
                                                    width: 300,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                {listImageView ?
                                                    <img
                                                        src={`https://serverkf.ccsoftwares.com/Assets/Items/${listImageView}`}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'contain'
                                                        }}
                                                        alt='imag'
                                                    />
                                                    :
                                                    <img
                                                        src={logo}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            borderRadius: '50%',
                                                            objectFit: 'contain'
                                                        }}
                                                        alt='imag'
                                                    />
                                                }
                                            </Card>
                                        </DialogContent>
                                    </Dialog>

                                </Card>
                            </form>
                        )}

                    </Formik>
                </TabPanel>

                <TabPanel value={tabIndex} index={1}>
                    <Card sx={{ padding: '15px' }}>
                        <CardHeader title={kitchenCardTitle('Kitchen Items')} />
                        <Divider />
                        <br />
                        <Grid container spacing={2} sx={{ mb: 2 }}>
                            <Grid item md={6} xs={12}>
                                <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                    <TextField
                                        sx={{ width: { md: '50%', xs: '60%' } }}
                                        variant="outlined"
                                        value={kitchenSearch}
                                        onChange={(e) => { setKitchenSearch(e.target.value); setKitchenPage(0); }}
                                        size='small'
                                    />
                                    <SearchIcon sx={{ color: 'action.active', mr: 1, my: 1 }} style={{ marginLeft: 10 }} />
                                </Box>
                            </Grid>
                        </Grid>
                        <TableContainer>
                            <Table sx={{ minWidth: 500 }} aria-label="kitchen items table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Item</TableCell>
                                        <TableCell>Qty</TableCell>
                                        <TableCell>In Date</TableCell>
                                        <TableCell>Out Date</TableCell>
                                        <TableCell>User</TableCell>
                                        <TableCell align="right">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(kitchenRowsPerPage > 0
                                        ? filteredKitchenItems.slice(
                                            kitchenPage * kitchenRowsPerPage,
                                            kitchenPage * kitchenRowsPerPage + kitchenRowsPerPage
                                        )
                                        : filteredKitchenItems
                                    ).map((row) => (
                                        <TableRow key={row.itemid}>
                                            <TableCell>{row.itemname}</TableCell>
                                            <TableCell>{row.qty}</TableCell>
                                            <TableCell>{row.indate}</TableCell>
                                            <TableCell>{row.outdate || '-'}</TableCell>
                                            <TableCell>{row.user}</TableCell>
                                            <TableCell align="right">
                                                <Tooltip title="Edit">
                                                    <IconButton onClick={() => openKitchenEdit(row)}>
                                                        <CreateIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                    {kitchenEmptyRows > 0 && (
                                        <TableRow style={{ height: 53 * kitchenEmptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                            colSpan={6}
                                            count={filteredKitchenItems.length}
                                            rowsPerPage={kitchenRowsPerPage}
                                            page={kitchenPage}
                                            slotProps={{
                                                select: {
                                                    inputProps: {
                                                        'aria-label': 'rows per page',
                                                    },
                                                    native: true,
                                                },
                                            }}
                                            onPageChange={handleKitchenChangePage}
                                            onRowsPerPageChange={handleKitchenChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </Card>
                </TabPanel>
            </Container>

            {/* item manegemnet dialog box */}
            <ItemDialog
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                isUpdateFromItem={false}
            />

            {/* item manegemnet dialog box */}
            {updateDialogOpen && selectedItem && <ItemUpdateDialog
                key={selectedItem.ItemID}
                item={selectedItem}
                dialogOpen={updateDialogOpen}
                setDialogOpen={setupdateDialogOpen}
                updateID={updateID}
                setUpdateID={setUpdateID}
            />}

            <CalculatedFoodDialog
                open={calcFoodDialogOpen}
                onClose={() => setCalcFoodDialogOpen(false)}
                mainItem={calcFoodMainItem}
                onSaved={() => GetAllItemDetailForGrid()}
            />

            <KitchenItemDialog
                open={kitchenDialogOpen}
                onClose={closeKitchenDialog}
                item={kitchenEditingItem}
                onSaved={() => GetKitchenItems()}
            />
        </>
    )
}

export default ItemManagement
